import type { ISerialize } from '@/objects/ISerialize';
import { StartingNumberHistory } from './StartingNumberHistory';

export class StartingNumberSetHistoryRequest implements ISerialize {
    public StartingNumberHistory: StartingNumberHistory[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { StartingNumberHistory?: StartingNumberHistory[] }) {
        this.StartingNumberHistory = values.StartingNumberHistory ?? [];
    }

    public serialize(): string {
        return '{' + `"StartingNumberHistory": [ ${this.StartingNumberHistory.map((x) => (!x ? null : x?.serialize()))} ]` + '}';
    }

    /**
     * Creates an instance of StartingNumberSetHistoryRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { StartingNumberHistory?: StartingNumberHistory[] }): StartingNumberSetHistoryRequest {
        return new StartingNumberSetHistoryRequest(values);
    }

    public static _FromServerJson(json: any): StartingNumberSetHistoryRequest {
        return new StartingNumberSetHistoryRequest({
            StartingNumberHistory: json.StartingNumberHistory?.map((x: any) => StartingNumberHistory._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of StartingNumberSetHistoryRequest from another instance of StartingNumberSetHistoryRequest.
     * @param other The StartingNumberSetHistoryRequest you want to clone
     * @returns A cloned StartingNumberSetHistoryRequest
     */
    public static FromOther(other: StartingNumberSetHistoryRequest): StartingNumberSetHistoryRequest {
        return StartingNumberSetHistoryRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return StartingNumberSetHistoryRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'StartingNumberSetHistoryRequest';
}
